import { render } from "./SeccionHome.vue?vue&type=template&id=7227252d&scoped=true"
import script from "./SeccionHome.vue?vue&type=script&lang=js"
export * from "./SeccionHome.vue?vue&type=script&lang=js"

import "./SeccionHome.vue?vue&type=style&index=0&id=7227252d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3fde62ecf17df48f63b2288f8ccd725b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7227252d"]])

export default __exports__